import { errorHandle } from 'redux/actions/error';
import apiService from 'shared/services/ApiService';
import {
  SET_LIST_TRANSACTIONS,
  PROCESSING,
  GET_TRANSACTION_DETAIL_MODAL_DATA,
  SET_TRANSACTION_DETAIL_MODAL,
  SET_TRANSACTION_REFUND_CONFIRM_MODAL,
  START_CANCEL_ORDER,
  UPDATE_CANCEL_ORDER,
  RESET_CANCEL_ORDER,
} from './types';
const { allBillerApiService } = apiService.getInstance();

export const getTransactionDetailModalData = () => ({
  type: GET_TRANSACTION_DETAIL_MODAL_DATA,
});

export const setTransactionDetailModal = (show, data) => ({
  type: SET_TRANSACTION_DETAIL_MODAL,
  show,
  data,
});

export const setListTransactions = (data, filter) => ({
  type: SET_LIST_TRANSACTIONS,
  payload: data,
  filter,
});

export const setProcessing = () => ({
  type: PROCESSING,
});

export const setTransactionRefundConfirmModal = (show, selectedId) => ({
  type: SET_TRANSACTION_REFUND_CONFIRM_MODAL,
  show,
  selectedId,
});

export const startCancelOrder = () => ({
  type: START_CANCEL_ORDER,
});

export const updateCancelOrder = (response, error) => ({
  type: UPDATE_CANCEL_ORDER,
  response,
  error,
});

export const resetCancelOrder = () => ({
  type: RESET_CANCEL_ORDER,
});

export const getListTransactions = (
  paginationUrl,
  paramUrl = '',
) => dispatch => {
  dispatch(transactions.setProcessing());

  const orderUrl = `orders?${paginationUrl}${paramUrl}`;

  allBillerApiService
    .get(orderUrl)
    .then(transactions.onGetListTransactionsSuccess(dispatch))
    .catch(transactions.onGetListTransactionsError(dispatch));
};

export const onGetListTransactionsSuccess = dispatch => response => {
  if (response.status === 200) {
    const { payload, pagination } = response.data;
    dispatch(transactions.setListTransactions(payload, pagination));
  }
};

export const onGetListTransactionsError = dispatch => error => {
  errorHandle(error);
  dispatch(transactions.setListTransactions([]));
};

export const getInvoice = orderId => dispatch => {
  dispatch(transactions.getTransactionDetailModalData());

  const url = `/orders/${orderId}/invoices`;

  allBillerApiService
    .get(url)
    .then(transactions.onGetInvoiceSuccess(dispatch))
    .catch(transactions.onGetInvoiceError(dispatch));
};

export const onGetInvoiceSuccess = dispatch => response => {
  if (response.status === 200) {
    const { payload } = response.data;
    dispatch(transactions.setTransactionDetailModal(true, payload));
  }
};

export const onGetInvoiceError = dispatch => error => {
  errorHandle(error);
  dispatch(transactions.setTransactionDetailModal(false, []));
};

export const cancelOrder = orderId => dispatch => {
  dispatch(transactions.startCancelOrder());

  const url = `/orders/${orderId}/cancel`;

  allBillerApiService
    .post(url)
    .then(transactions.onCancelOrderSuccess(dispatch))
    .catch(transactions.onCancelOrderFailed(dispatch));
};

export const onCancelOrderSuccess = dispatch => response => {
  if (response.status === 200 || response.status === 202) {
    dispatch(transactions.updateCancelOrder(response.data, ''));
  }
};

export const onCancelOrderFailed = dispatch => error => {
  dispatch(transactions.updateCancelOrder({}, error.response.data));
};

const transactions = {
  setListTransactions,
  setProcessing,
  getListTransactions,
  onGetListTransactionsSuccess,
  onGetListTransactionsError,
  getTransactionDetailModalData,
  setTransactionDetailModal,
  setTransactionRefundConfirmModal,
  getInvoice,
  onGetInvoiceSuccess,
  onGetInvoiceError,
  updateCancelOrder,
  startCancelOrder,
  cancelOrder,
  onCancelOrderSuccess,
  onCancelOrderFailed,
  resetCancelOrder,
};

export default transactions;
